import React from 'react';

import { useIntl } from 'react-intl';

import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';
import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';

import messages from '../../../common/messages';
import { PreviewPanelAction } from '../../../common/ui/preview-panel-action';
import type { PreviewPanelMoreDropdownProps } from './types';

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelMoreDropdown = ({
	dropdownActions,
	testId,
}: PreviewPanelMoreDropdownProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<DropdownMenu<HTMLButtonElement>
			trigger={({ triggerRef, ...props }) => {
				return (
					<PreviewPanelAction
						label={formatMessage(messages.previewPanelMoreDropdownActionLabel)}
						icon={ShowMoreHorizontalIcon}
						ref={triggerRef}
						{...props}
					/>
				);
			}}
			testId={testId}
			shouldRenderToParent
		>
			<DropdownItemGroup>
				{dropdownActions.map((action, index) => {
					return (
						<DropdownItem
							key={index}
							onClick={action.onClick}
							testId={action.testId}
							href={action.href}
							target={'_blank'}
						>
							{action.label}
						</DropdownItem>
					);
				})}
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
